import * as CONST from '../util/app-constants';
import { NotificationManager } from 'react-notifications';

const AWS = require('aws-sdk/dist/aws-sdk-react-native');

AWS.config.region = CONST.REGION; // 1. Enter your region
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: CONST.IDENTITY_POOL_ID, // 2. Enter your identity pool
});
AWS.config.credentials.get(() => {

});
const bucketName = CONST.BUCKET_NAME; // Enter your bucket name
const bucket = new AWS.S3({
  params: {
    Bucket: bucketName,
  },
});

export function uploadThemeConfig(fileContent, fileName) {
  const promiseForThemeUpload = new Promise((resolve, reject) => {
    const file = new Blob([fileContent], { type: 'plain/text' });
    if (file) {
      const objKey = fileName;
      const params = {
        Key: objKey,
        ContentType: file.type,
        Body: file,
        ACL: 'public-read',
      };

      bucket.putObject(params, (err, data) => {
        if (err) {
          NotificationManager.error(err.message);
          reject(err);
        } else {
          // NotificationManager.success(uploadType + " successfully updated.");
          resolve(data);
        }
      });
    }
  });

  return promiseForThemeUpload;
}

export function uploadProfileImage(fileChooser, username) {
  const file = fileChooser.files[0];

  const promiseForImageUpload = new Promise((resolve, reject) => {
    if (file) {
      // Check file type and show error if file type is not an image of type jgp, jpeg or png
      if (file.type === 'image/jpeg' || file.type === 'image/png') {
        const objKey = `profile/${username}`;
        const params = {
          Key: objKey,
          ContentType: file.type,
          Body: file,
          ACL: 'public-read',
        };

        bucket.putObject(params, (err, data) => {
          if (err) {
            reject(err);
          } else {
            resolve(data);
            // listObjs(objKey);
          }
        });
      } else {
        reject(new Error('Only file types of type JPG, JPEG and PNG are supported.'));
      }
    } else {
      reject(new Error('Please upload a file'));
    }
  });

  return promiseForImageUpload;
}

export function uploadLogo(fileChooser, name) {
    const file = fileChooser.files[0];

    const promiseForImageUpload = new Promise((resolve, reject) => {
        if (file) {
            // Check file type and show error if file type is not an image of type jgp, jpeg or png
            if (file.type === 'image/jpeg' || file.type === 'image/png') {
                const objKey = `logos/${name}`;
                const params = {
                    Key: objKey,
                    ContentType: file.type,
                    Body: file,
                    ACL: 'public-read',
                };

                bucket.putObject(params, (err, data) => {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(data);
                        // listObjs(objKey);
                    }
                });
            } else {
                reject(new Error('Only file types of type JPG, JPEG and PNG are supported.'));
            }
        } else {
            reject(new Error('Please upload a file'));
        }
    });

    return promiseForImageUpload;
}



// WEBPACK FOOTER //
// ./util/fileManager.js